import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { AppProvider } from './Shell/AppContext';
import { BrowserRouter as Router, } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './Store/store';
import './App.css';
import AppV2 from './AppV2';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <AppProvider>
      <Router>
        <AppV2 />
      </Router>
    </AppProvider>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
